import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import investmentReducer from './slices/investmentSlice';
import walletReducer from './slices/walletSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    investments: investmentReducer,
    wallet: walletReducer,
  },
});